import TiaTacTae from "./components/TiaTacTae";



function App() {
  return (
    <div className="">
       <TiaTacTae/>
    </div>
  );
}

export default App;
